export const BACKUP_SECTION_EVENT = 'canvas-agent:backup:section';
